import { render, staticRenderFns } from "./AdminColor.vue?vue&type=template&id=0806b114&"
import script from "./AdminColor.vue?vue&type=script&lang=js&"
export * from "./AdminColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports